<template>
  <svg width="34" height="34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.918 11.333a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5ZM14.168 17H8.357a4.25 4.25 0 0 0-4.216 3.723l-.908 7.259a2.833 2.833 0 0 0 2.812 3.185h6.706M30.769 27.982l-.907-7.259A4.25 4.25 0 0 0 25.643 17h-3.122a4.25 4.25 0 0 0-4.216 3.723l-.908 7.259a2.833 2.833 0 0 0 2.813 3.185h7.747a2.833 2.833 0 0 0 2.812-3.185ZM24.082 11.333a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z"
      stroke="#153D49"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
